import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'anf-core-react';
import LinkToFullPDP from './LinkToFullPDP';

function ViewFullDetailsButton({
  tmntData,
}) {
  const { pdpViewFullDetails } = tmntData;

  return (
    <div data-testid="product-view-fulldetails" className="product-view-full-details-button-container">
      <LinkToFullPDP>
        <Button variant="tertiary-dark" isFullWidth>
          {pdpViewFullDetails?.value}
        </Button>
      </LinkToFullPDP>
    </div>
  );
}

ViewFullDetailsButton.propTypes = {
  tmntData: PropTypes.shape({
    pdpViewFullDetails: PropTypes.shape({
      value: PropTypes.string,
    }),
  }).isRequired,
};

export default ViewFullDetailsButton;
